import { useEffect, useState, useRef } from "react";
import "../../styles/stafflogin.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";
import MenuTab from "../../components/menu_tab";
import Banner from "../../components/banner";
import Button from "../../components/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faX,
  faIns,
  faLocation,
  faLocationPin,
  faPhone,
  faUserCheck,
  faWater,
  faPlug,
  faTools,
  faHeadset,
  faTachometer,
  faTachometerAlt,
  faFaucet,
  faFaucetDrip,
  faSync
} from "@fortawesome/free-solid-svg-icons";
import PostItem from "../../components/post_item";
import allstaffmeeting from "../../assets/imgs/staffmeeting.jpeg";
import UserInput from "../../components/UserInput";
import UserSelect from "../../components/UserSelect";
import StaffHeader from "../../components/staff/staffheader";
import StaffFooter from "../../components/staff/stafffooter";

export default function PostNewNews(props) {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleQuickServices, setToggleQuickServices] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // Add new state and ref for documents
  const [selectedDocs, setSelectedDocs] = useState([]);

  const title = useRef();
  const category = useRef();
  const description = useRef();
  const date = useRef();
  const fileRef = useRef();
  const docRef = useRef();

  const [body, updateBody] = useState({
    Title: null,
    // Type: null,
    Description: null,
    Date: null
  });

  const titleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(" ");
  };

  const validateForm = () => {
    let result = true;
    let d = { ...body };
    d.Title = title.current.getValue();
    d.Category = category.current.getValue();
    d.Description = description.current.getValue();
    d.Date = date.current.getValue();
    // Add each document file (optional)

    updateBody(d);
    setError("");

    if (!d.Title) {
      setError("Title cannot be blank!");
      return false;
    }

    if (!d.Description || d.Description.length < 10) {
      setError("Enter a sufficient news description!");
      return false;
    }

    if (!fileRef.current.files || fileRef.current.files.length === 0) {
      setError("Upload at least one image!");
      return false;
    }

    if (!d.Date) {
      setError("Enter a valid date for the news posting!");
      return false;
    }

    return true;
  };

  const createNewsPost = () => {
    if (!validateForm()) return;

    const formData = new FormData();

    // Add text fields
    for (const key in body) {
      if (
        body.hasOwnProperty(key) &&
        body[key] !== undefined &&
        body[key] !== null
      ) {
        formData.append(key, body[key]);
      }
    }

    // Add each image file
    const files = fileRef.current.files;
    for (let i = 0; i < files.length; i++) {
      formData.append("photos", files[i]); // key: 'photos' aligns with backend
    }

    const docs = docRef.current.files;

    if (docs && docs.length > 0) {
      for (let i = 0; i < docs.length; i++) {
        formData.append("documents", docs[i]); // key: 'documents' aligns with backend
      }
    }

    // Debugging
    for (let pair of formData.entries()) {
      
    }

    setLoading(true);
    

    fetch(`/api/news/post`, {
      method: "POST",
      credentials: "include",
      headers: {
        // "Content-Type": "application/json", Never have this when sending files
        Accept: "application/json",
      },
      body: formData,
    })
      .then((response) => {
        
        if (response.ok) {
          return response.json();
        } else throw Error("");
      })
      .then((data) => {
        
        setLoading(false);
        if (data.success) {
          setError(data.message);
          setTimeout(() => {
            window.location.href = "/admin/tenders";
          }, 1500);
        } else {
          setError(data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
      });

  };

  return (
    <div className="body">
      <Banner />
      <StaffHeader toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      {toggleMenu && <MenuTab toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />}

      <div className="login-page">
        <div className="login-container">
          <h2>Post New News or Event</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <UserInput ref={title} label="Title" type="text" id="title" placeholder="Enter news or event title" />
            <UserSelect ref={category} label="Type" data = {["Meeting", "Public Engagement", "Project", , "Activity"]} />
            <UserInput ref={date} label="Date" type="date" id="date" placeholder="Enter date of the news or event" />
            <UserInput ref={description} label="Description" type="textarea" id="description" placeholder="Enter news description" />
    
            <div className="form-group">
              <label>Add image files</label>
              <input
                id="file"
                ref={fileRef}
                type="file"
                multiple
                onChange={(e) => setSelectedFiles(e.target.files)}
                accept=".png, .jpg, .jpeg"
              />
              {selectedFiles && (
                <ul>
                  {Array.from(selectedFiles).map((file, i) => (
                    <li key={i}>{file.name}</li>
                  ))}
                </ul>
              )}
            </div>

            <div className="form-group">
              <label>Add document files (optional)</label>
              <input
                id="doc"
                ref={docRef}
                type="file"
                multiple
                onChange={(e) => setSelectedDocs(e.target.files)}
                accept=".pdf, .doc, .docx"
              />
              {selectedDocs && (
                <ul>
                  {Array.from(selectedDocs).map((file, i) => (
                    <li key={i}>{file.name}</li>
                  ))}
                </ul>
              )}
            </div>
            <h6 style={{ color: error?.includes("successfully") ? "green" : "red" }}>{error}</h6>

            <button type="Post" className="login-btn" onClick={() => createNewsPost()}>
              {loading ? "Posting..." : "Post News"}
            </button>
          </form>
        </div>
      </div>

      <StaffFooter />
    </div>
  );
}
